import { Route, lazyRouteComponent } from "@tanstack/react-router";
import {
  searchParamsSchema,
  confirmationQueryOptions,
} from "../containers/confirmation-overview";
import { rootRoute } from "./root";

export const confirmationRoute = new Route({
  validateSearch: (search) => searchParamsSchema.parse(search),
  loaderDeps: ({ search: { reservationId } }) => ({
    reservationId,
  }),
  loader: (options) =>
    options.context.queryClient.ensureQueryData(
      confirmationQueryOptions(options.deps),
    ),
  getParentRoute: () => rootRoute,
  path: "/confirmation",
  component: lazyRouteComponent(() => import("../pages/confirmation")),
});
